import * as ToastPrimitive from '@radix-ui/react-toast';
import { Cross1Icon } from '@radix-ui/react-icons';
import { cn } from '@packages/utils';
import { useToast } from './use-toast';

export const Toaster = () => {
  const { toasts } = useToast();
  return (
    <ToastPrimitive.Provider duration={4000} swipeDirection="right">
      {toasts.map(({ id, title, description, action, variant, open, onOpenChange }) => (
        <ToastPrimitive.Root
          key={id}
          open={open}
          onOpenChange={onOpenChange}
          className={cn(
            'pointer-events-auto relative flex w-full items-start justify-between gap-3 border-2 border-ww-charcoal p-4 shadow-hard',
            variant === 'destructive'
              ? 'bg-ww-orange text-paper-50'
              : 'bg-paper-50 text-ww-charcoal',
          )}>
          <div className="grid gap-1">
            {title ? (
              <ToastPrimitive.Title className="font-sans text-sm font-bold uppercase tracking-wide">
                {title}
              </ToastPrimitive.Title>
            ) : null}
            {description ? (
              <ToastPrimitive.Description className="font-sans text-sm leading-snug">
                {description}
              </ToastPrimitive.Description>
            ) : null}
          </div>
          {action}
          <ToastPrimitive.Close
            className="shrink-0 opacity-70 transition hover:opacity-100"
            aria-label="Schließen">
            <Cross1Icon />
          </ToastPrimitive.Close>
        </ToastPrimitive.Root>
      ))}
      <ToastPrimitive.Viewport className="fixed bottom-0 right-0 z-[100] m-0 flex w-full max-w-sm list-none flex-col gap-2 p-4 outline-none" />
    </ToastPrimitive.Provider>
  );
};
